export default __webpack_public_path__ + "static/media/logoP-lao.ffa2a8c0.svg";